import { Port } from '../../types/models'
import { BatteryOptimizerSocPlanConfig, BatteryOptimizerSocPlanPort, PortConfigBatteryOptimizerSocPlan } from '../../types/ports'
import { DeviceControl } from '../DeviceControl'
import { PortControl } from './PortControl'

/**
 * Controller for battery optimizer SoC plan (port 0x223).
 *
 * Carries the per-slot SoC trajectory that pairs 1:1 with the plan slots on
 * BATTERY_OPTIMIZER2. The data is read by the BatteryStateWidget.
 */
export class BatteryOptimizerSocPlanPortControl extends PortControl<BatteryOptimizerSocPlanPort, BatteryOptimizerSocPlanConfig> {

  port: BatteryOptimizerSocPlanPort

  constructor(deviceControl: DeviceControl, port: Port) {
    super(deviceControl, port)
    this.port = port as BatteryOptimizerSocPlanPort
  }

  getDescription(): string { return this.app.t('Battery Optimizer SoC Plan') }

  getTypeName(): string { return this.app.t('PortType-BatteryOptimizerSocPlan') }

  get group(): string { return this.app.t('PortGroup-Optimization') }

  getConfigDefaults(): PortConfigBatteryOptimizerSocPlan {
    return {}
  }
}
